<template>
    <div>
        <Wp_nav_bar title="修改密码"></Wp_nav_bar>

        <div style="padding: 5%">

<!--            <div class="modify_tip_div">-->
<!--                <span style="font-size: 16px">密码修改要求说明：</span><br>-->
<!--                ①，密码长度为6-15位英文或数字；<br>-->
<!--                ②，识别下方"万品京选"公众号二维码，进行关注；<br>-->
<!--                ③，在"万品京选"公众号中选择"登录"；<br>-->
<!--                ④，在弹出的登录界面中，输入"会员编号"和"登录密码"即可登录超级会员后台；-->
<!--            </div>-->

            <div class="modify_input_div">
                <van-field
                        class="modify_input"
                        label-width="90px"
                        v-model="old_password"
                        :type="field_type"
                        label="旧密码"
                        placeholder="请输入旧密码"
                        required
                        clearable
                ></van-field>
            </div>

            <div class="modify_input_div">
                <van-field
                        class="modify_input"
                        label-width="90px"
                        v-model="new_password"
                        :type="field_type"
                        label="新密码"
                        placeholder="请输入新密码(6-15位英文或数字)"
                        required
                        clearable
                ></van-field>
            </div>

            <div class="modify_input_div">
                <van-field
                        class="modify_input"
                        label-width="90px"
                        v-model="check_new_password"
                        :type="field_type"
                        label="确认新密码"
                        placeholder="请再次输入新密码"
                        required
                        clearable
                ></van-field>
            </div>

            <div style="margin-top: 12px; margin-left: 2px">
                <van-checkbox v-model="checked" shape="square" style="" @change="checkBoxChanged">明文显示</van-checkbox>
            </div>

            <div style="text-align: center; margin-top: 20px">
                <van-button
                        type="danger"
                        size="large"
                        style="margin-top: 10%; border-radius:4px"
                        @click="commitModify"
                        :disabled="modify_button_status"
                        :loading="loading_status"
                        :loading-text="loading_text"
                >
                    修&nbsp;&nbsp;改
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_my_modify_password",
        components: {Wp_nav_bar},
        data(){
            return{
                old_password: "",
                new_password: "",
                check_new_password: "",

                field_type: "password",//text
                right_icon: "eye-o",//eye

                checked: false,

                // modify_button_text: "修&nbsp;&nbsp;改",
                modify_button_status: false,

                loading_status: false,
                loading_text: "密码修改中..."
            }
        },

        created(){
            // //判断是否弹出登录界面
            // let isLogin = this.$store.getters.isLogin;
            // this.$log("isLogin = " + isLogin);
            // if(isLogin!==true) {
            //     this.$bus.$emit('toLogin', '登录吧,牛宝宝');
            //
            //     window.location.replace("/index.html");
            // }
            this.initOriginalPwd();
        },

        methods:{
            /**
             * 初始化原始密码
             */
            initOriginalPwd(){
                if(this.$store.state.original_p && typeof (this.$store.state.original_p) !== "undefined"){
                    this.old_password = this.$store.state.original_p;
                }
            },

            checkBoxChanged(value){
                this.$log(value)
                if(value){
                    this.field_type = "text";
                }else{
                    this.field_type = "password";
                }
            },

            /**
             * 确认修改密码
             */
            commitModify(){
                let old_pwd = this.old_password;
                let new_pwd = this.new_password;
                let chenc_new_pwd = this.check_new_password;

                if(!old_pwd || !new_pwd || !chenc_new_pwd){
                    this.$dialog.alert({
                        title: "错误",
                        message: "旧密码或新密码不可为空，请按要求输入密码",
                    });
                    return;
                }

                if(old_pwd && (old_pwd.length < 6 || old_pwd.length > 15)){
                    this.$dialog.alert({
                        title: "错误",
                        message: "旧密码长度有问题，请按要求输入",
                    });
                    return;
                }

                if(new_pwd && (new_pwd.length < 6 || new_pwd.length > 15)){
                    this.$dialog.alert({
                        title: "错误",
                        message: "新密码长度有问题，请按要求输入",
                    });
                    return;
                }

                if(chenc_new_pwd && (chenc_new_pwd.length < 6 || chenc_new_pwd.length > 15)){
                    this.$dialog.alert({
                        title: "错误",
                        message: "确认新密码长度有问题，请按要求输入",
                    });
                    return;
                }

                if(new_pwd !== chenc_new_pwd){
                    this.$dialog.alert({
                        title: "错误",
                        message: "两次输入的'新密码'不一致，请检查",
                    });
                    return;
                }

                let params = {
                    uid: this.$store.state.username,
                    opwd: old_pwd,
                    npwd: new_pwd
                };

                this.modify_button_status = true;
                this.loading_status = true;

                // setTimeout(()=>{
                //     this.modify_button_status = false;
                //     this.loading_status = false;
                // },2000)

                this.$modifyPassword(params, response=>{
                    // this.modify_button_status = false;
                    // this.loading_status = false;
                    setTimeout(()=>{
                        this.modify_button_status = false;
                        this.loading_status = false;
                    },2000)

                    if(response.code === 200){
                        if(this.$config.project === 'mini'){
                            this.$dialog.alert({
                                title: response.msg,
                                message: "请退出重新登录",
                                confirmButtonText: "确定"
                            }).then(()=>{
                                // this.$common.navigateBack();
                                this.$common.reLaunchMiniProgramPage('/pages/login/login_pw/login_pw?relogin=true');
                            });
                        }else{
                            //修改成功，直接退出登录
                            this.$store.commit('logout');

                            this.$dialog.alert({
                                title: response.msg,
                                message: "请退出重新登录",
                                confirmButtonText: "确定"
                            }).then(()=>{
                                //跳转主界面
                                window.location.replace("/index.html");
                            });
                        }

                    }else if(response.code === 3006){
                        this.$dialog.alert({
                            title: response.msg,
                            message: "请重新输入",
                            confirmButtonText: "确定"
                        }).then(()=>{
                            //清除输入框中的原内容
                            this.old_password = "";
                            this.new_password = "";
                            this.check_new_password = "";
                        })
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .modify_tip_div {
        border: 1px solid #03FFF255;
        border-radius: 4px;
        padding: 10px;
        background-color: #03FFF222;
        font-size: 15px;
        line-height: 25px;
    }

    .modify_input_div {
        margin-top: 5%;
        padding: 2px;
        border-radius: 4px;
        border: 1px solid #E52212
    }

    .modify_input {
        font-size: 15px
    }
</style>